export const formatBalance = (summ?: number): string => {
    if (summ === undefined) return '';

    const sign = summ > 0 ? '+' : '';
    return `${sign}${summ}`;
};

export const fixedNumber = (num: number): number => {
    return Number(num?.toFixed(2) ?? 0);
};
